Element.prototype.parents = function (selector) {
    var elements = [];
    var elem = this;
    var ishaveselector = selector !== undefined;

    if (!Element.prototype.matches) {
        Element.prototype.matches = Element.prototype.msMatchesSelector;
    }

    while ((elem = elem.parentElement) !== null) {
        if (elem.nodeType !== Node.ELEMENT_NODE) {
            continue;
        }

        if (!ishaveselector || elem.matches(selector)) {
            elements.push(elem);
        }
    }

    return elements;
};

/**
 * @module Form
 */
(function Form() {

    var recaptureElements = document.querySelectorAll('.techdivision-form-recapture');

    /**
     * Gets called after the google api has be loaded successfully
     */
    var apiLoaded = function () {
        [].forEach.call(recaptureElements, function (recaptureFormElement) {
            var form = recaptureFormElement.parents('form')[0];
            var submitButton = form.querySelectorAll(".td-form-submit-button")[0];
            grecaptcha.render(submitButton, {
                'sitekey': recaptureFormElement.getAttribute('data-sitekey'),
                'callback': function (token) {
                    recaptureFormElement.value = token;
                    if (form.checkValidity() === true)  {
                        HTMLFormElement.prototype.submit.call(form);
                    } else {
                        // if validity == false then delete old button and add new 
                        // for html5 validity
                        var newSubmitButton = $(submitButton).clone();
                        newSubmitButton.insertAfter(submitButton);
                        $(submitButton).detach();
                        $(newSubmitButton).click();
                    }
                }
            });
        });
    };

    // load api
    if (recaptureElements.length) {
        var s = document.createElement("script");
        s.type = "text/javascript";
        s.src = "https://www.google.com/recaptcha/api.js?onload=TechDivisionFormReCaptchaApiLoaded&render=explicit";
        document.head.appendChild(s);
    }

    // export api
    window.TechDivisionFormReCaptchaApiLoaded = apiLoaded;
})();